/**
 * 常量
 */
export default {
	USER_TOKEN: 'token',
	USER_INFO: "userInfo"
}
